import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { PopupProvider } from 'react-popup-manager';
import Routes from 'routes';
// import './styles/crema.less';
import Loading from 'components/molecules/Loading';
import Authority from 'components/authority';
import DefaultLayout from 'components/organisms/DefaultLayout';
import MobileLayout from 'components/organisms/MobileLayout';
import 'antd/dist/antd.css';
import './styles/common.scss';
import { isMobile } from 'react-device-detect';

function App() {
  return (
    <PopupProvider>
      {(isMobile) ? (
        <Suspense fallback={<Loading size="default" />}>
          <MobileLayout>
            <Authority>{useRoutes(Routes.paths)}</Authority>
          </MobileLayout>
        </Suspense>
      ):(
        <Suspense fallback={<Loading size="large" />}>
          <DefaultLayout>
            <Authority>{useRoutes(Routes.paths)}</Authority>
          </DefaultLayout>
        </Suspense>
      )}
    </PopupProvider>
  );
}

export default App;
